<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="OT" id="_idParaDest-2"><a href="#/Wolterstorff_The_God_We_Worship_text_CC3#toc2"></a><a id="_idTOCAnchor-2"></a>Acknowledgments</p>
<p class="BODYFLUSH">In the fall of 2013 I delivered the Kantzer Lectures in Revealed Theology at Trinity Evangelical Divinity School in Deerfield, Illinois. This essay is a revision of the text of those lectures. I thank Trinity for the honor of being invited to give the lectures, for the extraordinary hospitality I enjoyed while I was on the campus, and for the astute and helpful comments that students and professors made in the question period after each lecture. I also thank a group of students at the University of Virginia, organized by Matthew Puffer, for reading and offering me helpful comments on an early draft of the lectures; and Terence Cuneo, for likewise reading and commenting on a version of these lectures.</p>
</div>
<div class="_idGenObjectLayout-1">
<div class="_idGenPageitem-1 _idGenObjectStyleOverride-1">
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Wolterstorff_The_God_We_Worship_text_CC-6.vue?25a4ffb1